import add from '@/assets/images/commonIcon/add.png';
import deleteIcon from '@/assets/images/commonIcon/delete.png';
import upload from '@/assets/images/commonIcon/upload.png';
import approval from '@/assets/images/commonIcon/approval.png';
import fileIcon from '@/assets/images/UploadTenantModal/fileIcon.png';
import docIcon from '@/assets/images/UploadTenantModal/docIcon.png';
import csvIcon from '@/assets/images/UploadTenantModal/csvIcon.png';
import failIcon from '@/assets/images/UploadTenantModal/fail.png';
import successIcon from '@/assets/images/UploadTenantModal/success.png';
import uploadIcon from '@/assets/images/UploadTenantModal/uploadIcon.png';

// EmployeesInfo
import EmployeesInfoAccountInfo from '@/assets/images/EmployeesInformation/AccountInfo.png';
import EmployeesInfoEmployeeInfo from '@/assets/images/EmployeesInformation/EmployeeInfo.png';
import EmployeesInfoEmploymentInfo from '@/assets/images/EmployeesInformation/EmploymentInfo.png';
import EmployeesInfoRentalInfo from '@/assets/images/EmployeesInformation/RentalInfo.png';
import EmployeesInfoOtherInfo from '@/assets/images/EmployeesInformation/OtherInfo.png';
import EmployeesInfoUpload from '@/assets/images/EmployeesInformation/Upload.png';

// ApprovalSummary Insurance View Payment History
import ASIDYear from '@/assets/images/commonIcon/ASIDYear.png';
import ASIDGlacct from '@/assets/images/commonIcon/ASIDGlacct.png';
import ASIDVacant from '@/assets/images/commonIcon/ASIDVacant.png';
import ASIDEviction from '@/assets/images/commonIcon/ASIDEviction.png';
import ASIDIncome from '@/assets/images/commonIcon/ASIDIncome.png';
import ASIDCashFlow from '@/assets/images/commonIcon/ASIDCashFlow.png';
import ASIDVacancy from '@/assets/images/commonIcon/ASIDVacancy.png';

// Dashboard operatingStatementMonthsReport
import OSMRExpand from '@/assets/images/commonIcon/expand.png';
import OSMRRetract from '@/assets/images/commonIcon/retract.png';

export default {
    add,
    upload,
    approval,
    deleteIcon,
    fileIcon,
    docIcon,
    csvIcon,
    failIcon,
    successIcon,
    uploadIcon,
    EmployeesInfoAccountInfo,
    EmployeesInfoEmployeeInfo,
    EmployeesInfoEmploymentInfo,
    EmployeesInfoRentalInfo,
    EmployeesInfoOtherInfo,
    EmployeesInfoUpload,
    ASIDYear,
    ASIDGlacct,
    ASIDVacant,
    ASIDEviction,
    ASIDIncome,
    ASIDCashFlow,
    ASIDVacancy,
    OSMRExpand,
    OSMRRetract,
}
